// extracted by mini-css-extract-plugin
export default {"container":"container__K8jZj","overlay":"overlay__ceRrz","text":"text__KYbUo"};